import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from 'react-router-dom'
import Root from './common/Root'
import NotFound from './common/NotFound'
import Error from './common/Error'
import IndexRoute from './routes/index/IndexRoute'
import PrivacyByDate from './routes/privacy/PrivacyByDate'
import OAuthRedirect from './routes/login/OAuthRedirect'
import AdminTipsRoute from './routes/admin/AdminTipsRoute'
import AdminRoute from './routes/admin/AdminRoute'
import AdminAuthorRoute from './routes/admin/AdminAuthorRoute'
import LibraryDetailRoute from './routes/library/find/LibraryDetailRoute'
import CommunityRoute from './routes/community/CommunityRoute'
import LibraryRoute from './routes/library/find/LibraryRoute'
import BookRoute from './routes/book/BookRoute'
import LibraryNearRoute from './routes/library/near/LibraryNearRoute'
import CommunityTipsRoute from './routes/community/tips/CommunityTipsRoute'
import CommunityTipsDetailRoute from './routes/community/tips/CommunityTipsDetailRoute'
import PopularBookRoute from './routes/community/popular-books/PopularBookRoute'
import BookStatisticsRoute from './routes/book/statitics/BookStatisticsRoute'
import BookStatisticsCategoryBooksRoute from './routes/book/statitics/cards/BookStatisticsCategoryBooksRoute'
import BookStatisticsLanguageBooksRoute from './routes/book/statitics/cards/BookStatisticsLanguageBooksRoute'
import BookMineRoute from './routes/book/mine/BookMineRoute'
import LibraryMembershipDetailRoute from './routes/library/membership/LibraryMembershipDetailRoute'
import LibraryRegionRoute from './routes/library/location/LibraryRegionRoute'
import LibraryAddMembershipRoute from './routes/library/membership/add/LibraryAddMembershipRoute'
import LoginRoute from './routes/login/LoginRoute'
import BookDetailRoute from './routes/book/detail/BookDetailRoute'
import BookGoalRoute from './routes/book/goal/BookGoalRoute'
import AddBookRoute from './routes/book/add/AddBookRoute'
import AddRoute from './routes/AddRoute'
import BooksitoutProductsRoute from './booksitout/BooksitoutProductsRoute'
import BooksitoutValuesRoute from './booksitout/BooksitoutValuesRoute'
import BooksitoutProductDetailRoute from './booksitout/BooksitoutProductDetailRoute'
import BookIsbnRoute from './routes/book/isbn/BookIsbnRoute'
import BookAuthorRoute from './routes/book/author/BookAuthorRoute'
import BookPublisherRoute from './routes/book/publisher/BookPublisherRoute'
import BookEditRoute from './routes/book/edit/BookEditRoute'
import ProfileRedirectRoute from './routes/appUsers/profiles/ProfileRedirectRoute'
import ProfileRoute from './routes/appUsers/profiles/ProfileRoute'
import SettingsRoute from './routes/appUsers/settings/SettingsRoute'
import SettingsPersonalInfoRoute from './routes/appUsers/settings/SettingsPersonalInfoRoute'
import SettingsProfileRoute from './routes/appUsers/settings/SettingsProfileRoute'
import ProfileUsersListRoute from './routes/appUsers/profiles/ProfileUsersListRoute'
import SettingsPersonalInfoAddOAuthRedirectRoute
    from './routes/appUsers/settings/SettingsPersonalInfoAddOAuthRedirectRoute'
import LibraryRankingRoute from './routes/library/ranking/LibraryRankingRoute'
import FaqRoute from './routes/faq/FaqRoute'
import SettingsSearchRoute from './routes/appUsers/settings/SettingsSearchRoute'
import SettingsBookShelfRoute from './routes/appUsers/settings/SettingsBookShelfRoute'
import BookCalendarRoute from './routes/book/calendar/BookCalendarRoute'
import SettingsWithdrawRoute from './routes/appUsers/settings/SettingsWithdrawRoute'
import PwaRoute from './routes/community/PwaRoute'
import LibraryMembershipRoute from './routes/library/membership/LibraryMembershipRoute'
import BookRecommendersRoute from "./routes/community/book-recommendations/BookRecommendersRoute";
import BookRecommendersDetailRoute from "./routes/community/book-recommendations/BookRecommendersDetailRoute";

const router = createBrowserRouter(
	createRoutesFromElements(
		<Route path="/" element={<Root />} errorElement={<Error />}>
			<Route path="*" element={<NotFound />} />
			<Route path="/" element={<IndexRoute />} />

			<Route path="/values" element={<BooksitoutValuesRoute />} />

			<Route path="/faq" element={<FaqRoute />} />

			<Route path="/users" element={<ProfileUsersListRoute />} />
			<Route path="/users/:userId" element={<ProfileRoute />} />
			<Route path="/users/me/redirect" element={<ProfileRedirectRoute />} />

			<Route path="/settings" element={<SettingsRoute />} />
			<Route path="/settings/personal-infos" element={<SettingsPersonalInfoRoute />} />
			<Route path="/settings/personal-infos/add-account/:provider" element={<SettingsPersonalInfoAddOAuthRedirectRoute />} />
			<Route path="/settings/profiles" element={<SettingsProfileRoute />} />
			<Route path="/settings/search" element={<SettingsSearchRoute />} />
			<Route path="/settings/book-shelf" element={<SettingsBookShelfRoute />} />
<Route path="/settings/withdraw" element={<SettingsWithdrawRoute />} />

			<Route path="/book" element={<BookRoute />} />
			<Route path="/book/mine" element={<BookMineRoute />} />
			<Route path="/book/mine/:bookId" element={<BookDetailRoute />} />
			<Route path="/book/mine/:bookId/edit" element={<BookEditRoute />} />
			<Route path="/book/goal" element={<BookGoalRoute />} />
			<Route path="/book/statistics" element={<BookStatisticsRoute />} />
			<Route path="/book/calendar" element={<BookCalendarRoute />} />
			<Route path="/book/statistics/categories/:category" element={<BookStatisticsCategoryBooksRoute />} />
			<Route path="/book/statistics/languages/:language" element={<BookStatisticsLanguageBooksRoute />} />
			<Route path="/book/author/:urlName" element={<BookAuthorRoute />} />
			<Route path="/book/publisher/:urlName" element={<BookPublisherRoute />} />
			<Route path="/book/:isbn" element={<BookIsbnRoute />} />

			<Route path="/library" element={<LibraryRoute />} />
			<Route path="/library/near" element={<LibraryNearRoute />} />
			<Route path="/library/ranking" element={<LibraryRankingRoute />} />
			<Route path="/library/:libraryId" element={<LibraryDetailRoute />} />
			<Route path="/library/by-region/:region" element={<LibraryRegionRoute />} />
			<Route path="/library/by-region/:region/:regionDetail" element={<LibraryRegionRoute />} />
			<Route path="/library/membership" element={<LibraryMembershipRoute />} />
			<Route path="/library/membership/:membershipId" element={<LibraryMembershipDetailRoute />} />

			<Route path="/community" element={<CommunityRoute />} />
			<Route path="/community/tips" element={<CommunityTipsRoute />} />
			<Route path="/community/tips/:tipsId" element={<CommunityTipsDetailRoute />} />
			<Route path="/community/popular-books" element={<PopularBookRoute />} />
			<Route path="/community/book-recommendations" element={<BookRecommendersRoute />} />
			<Route path="/community/book-recommendations/:recommenderId" element={<BookRecommendersDetailRoute />} />

			<Route path="/login" element={<LoginRoute />} />
			<Route path="/login/oauth/:provider" element={<OAuthRedirect />} />

			<Route path="/admin" element={<AdminRoute />} />
			<Route path="/admin/tips/:tipsId" element={<AdminTipsRoute />} />
			<Route path="/admin/author/:urlName" element={<AdminAuthorRoute />} />

			<Route path="/pwa" element={<PwaRoute />} />

			<Route path="/add" element={<AddRoute />}>
				<Route path="book" element={<AddBookRoute />} />
				<Route path="membership" element={<LibraryAddMembershipRoute />} />
			</Route>

			<Route path="/privacy/:date" element={<PrivacyByDate />} />

			{/* for booksitout */}
			<Route path="/products" element={<BooksitoutProductsRoute />} />
			<Route path="/products/:productName" element={<BooksitoutProductDetailRoute />} />
			<Route path="/products/:productName/privacy/:date" element={<PrivacyByDate />} />
		</Route>,
	),
)

function App() {
	return (
		<div className="App">
			<RouterProvider router={router} />
		</div>
	)
}

export default App
